module.exports = function() {
  return new Worker("/" + "less-transpiler.74a88bd2.worker.js");
};